<form [formGroup]="form">
    <h3>Motivo</h3>
    <mat-form-field>
        <input matInput formControlName="motivo" maxlength="50" />
    </mat-form-field>
    <mat-error *ngIf="form.get('motivo')?.errors?.required">
        <span>Obligatorio</span>
    </mat-error>

    
    <button class="can" (click)="onCancelButtonClick()">Cancelar</button>
    <button class="accept" (click)="onAcceptButtonClick()" [disabled]="form.invalid">Acceptar</button>

</form>